import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/how-saint-compares-to-other-depression-treatment-options",
)({
  beforeLoad: () => {
    throw redirect({ to: "/compare-treatments", replace: true });
  },
});
